import type { HTMLAttributes } from "react";
import { cx } from "./cx";

export type CardTone = "card" | "sunken" | "green" | "blue";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Adds hover lift and a green border. Use only when the whole card is clickable. */
  interactive?: boolean;
  /** CSS padding value. Default 24px (--space-7). */
  padding?: string;
  /** card (white) · sunken (paper) · green / blue tint */
  tone?: CardTone;
}

const TONE: Record<CardTone, string> = {
  card: "bg-surface-card",
  sunken: "bg-surface-sunken",
  green: "bg-surface-tint-green",
  blue: "bg-surface-tint-blue",
};

/** White card on paper: 10px radius, hairline border, warm shadow. No coloured left borders. */
export function Card({ interactive, padding = "var(--space-7)", tone = "card", className, style, children, ...rest }: CardProps) {
  return (
    <div
      className={cx(
        "rounded-lg border border-border-subtle shadow-sm",
        TONE[tone],
        interactive && "cursor-pointer hover:border-green-300 hover:shadow-md",
        className,
      )}
      style={{ padding, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}
